import uuid from 'uuid/v4'
import store from '../store'
import { isEmpty } from '@/common/utils'

const KEY = 'client_id'

/**
 * load client id
 * @returns {Promise<String>}
 */
const loadClientId = async () => {
  let value = await store.get(KEY)

  if (isEmpty(value)) {
    value = uuid()

    await storeClientId(value)
  }

  return value
}

/**
 * store clientId
 * @param {String} value
 *
 * @returns {Promise<String>}
 */
const storeClientId = value => {
  return store.set(KEY, value)
}

export { storeClientId, loadClientId }
